module.exports = __webpack_public_path__ + "3b5faed8dc070925791752e0a2b3cf18.jpg";